module.exports = __webpack_public_path__ + "static/media/website-views.63a7e693.png";